<template>
  <section class="dashboard-card">
    <h3>Performance Impact</h3>

    <div class="impact-grid">
      <div class="impact-card">
        <span class="impact-value">Fuel</span>
        <p>Additional consumed bunker fuel</p>
      </div>

      <div class="impact-card">
        <span class="impact-value">Days</span>
        <p>Lost employment days due to less achieved speed</p>
      </div>

      <div class="impact-card">
        <span class="impact-value">Estimate</span>
        <p>Estimation of clean vessel employment days</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PerformanceImpactSection"
};
</script>

<style scoped>
.dashboard-card {
  background: var(--color-primary);
  border: 1px solid #dbe3ef;
  border-radius: 16px;
  padding: 18px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.dashboard-card h3 {
  margin: 0 0 14px;
  color: #0f172a;
  font-size: 18px;
}

.impact-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

.impact-card {
  min-height: 120px;
  border-radius: 14px;
  padding: 16px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
}

.impact-value {
  display: inline-block;
  margin-bottom: 8px;
  color: #c2410c;
  font-size: 15px;
  font-weight: 800;
}

.impact-card p {
  margin: 0;
  color: #475569;
  font-size: 14px;
  font-weight: 600;
}

@media (max-width: 900px) {
  .impact-grid {
    grid-template-columns: 1fr;
  }
}
</style>
